module.exports = __webpack_public_path__ + "static/media/conseillere_commerciale.7ddbc248.jpg";